var _path, _path2, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M486.598,367.304C502.872,333.649,512,295.89,512,256s-9.128-77.649-25.402-111.304L256,133.565 l-230.598,11.13C9.128,178.351,0,216.11,0,256s9.128,77.649,25.402,111.304L256,378.435L486.598,367.304z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91 C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.043,
    y: 244.87,
    style: {
      fill: "#FFDA44"
    },
    width: 333.913,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.565,
    y: 200.348,
    style: {
      fill: "#FFDA44"
    },
    width: 244.87,
    height: 22.261
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M380.025,256c0,0-57.243,66.783-124.025,66.783S189.217,256,189.217,256s0-66.783,66.783-66.783 S380.025,256,380.025,256z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256,322.783c-66.783,0-124.025-66.783-124.025-66.783S189.217,189.217,256,189.217"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211.478,
    y: 233.739,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 44.522
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 233.739,
    width: 22.261,
    height: 44.522
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0052B4"
    },
    cx: 89.043,
    cy: 256,
    r: 22.261
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0052B4"
    },
    cx: 422.957,
    cy: 256,
    r: 22.261
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.d9b6aa3c48e974737f7fc73dc36c172c.svg";
export { ForwardRef as ReactComponent };